// import {
//   ORGADMIN_COMPANIES_SHORT_NAME,
//   ORGADMIN_TEAM_SHORT_NAME,
//   ORGADMIN_USERS_SHORT_NAME,
//   ORGADMIN_NEWS_SHORT_NAME,
//   ORGADMIN_EVENTS_SHORT_NAME,
//   ORGADMIN_CATEGORIES_SHORT_NAME,
//   ORGADMIN_MAILCHIMP_SHORT_NAME,
//   ORGADMIN_WEDDING_SHORT_NAME,
//   ORGADMIN_SUBSCRIBERS_SHORT_NAME,
//   ORGADMIN_LANGUAGES_SHORT_NAME,
//   ORGADMIN_SEO_SHORT_NAME,
//   ORGADMIN_PROMOTIONS_SHORT_NAME,
// ORGADMIN_POLICYBRIEFS_REPORTS_SHORT_NAME,
// ORGADMIN_PODCASTS_SHORT_NAME

// } from "../../../Constants";
import DashboardIcon from "@mui/icons-material/Dashboard";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TuneIcon from "@mui/icons-material/Tune";
import EventIcon from "@mui/icons-material/Event";
import CelebrationIcon from "@mui/icons-material/Celebration";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import CategoryIcon from "@mui/icons-material/Category";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GavelIcon from "@mui/icons-material/Gavel";
import LanguageIcon from "@mui/icons-material/Language";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import PolicyIcon from "@mui/icons-material/Policy";
import PodcastsIcon from "@mui/icons-material/Podcasts";
import BusinessIcon from "@mui/icons-material/Business";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import { AddAlert, BreakfastDining, Slideshow } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import LockIcon from "@mui/icons-material/Lock";
import StyleIcon from "@mui/icons-material/Style";
import Users from "../../SuperAdmin/Users";
import NewsLetterPolicyBriefs from "../NewsLetterPolicyBriefs";
import Categories from "../Categories";
import Tags from "../Tags";
import Subscribers from "../Subscribers";
import Weddings from "../Weddings";
import Team from "../Team";
import Events from "../Events";
import Laws from "../Laws";
import Languages from "../Languages";
import SEO from "../SEO";
import Promotions from "../Promotions";
import Podcasts from "../Podcasts";
import Dashboard from "../Dashboard";
import ChangePassword from "../../Common/ChangePassword";
import Support from "../Support";
import MailChimp from "../MailChimp";
import SlideshowComponent from "../Slideshow";

const getIcon = (name) => {
  switch (name) {
    case "companyadmin_wedding":
      return <CelebrationIcon />;
    case "companyadmin_team":
      return <Diversity3Icon />;
    case "companyadmin_users":
      return <VpnKeyIcon />;
    case "companyadmin_languages":
      return <LanguageIcon />;
    case "companyadmin_seo":
      return <TuneIcon />;
    case "companyadmin_promotions":
      return <AddAlert />;
    case "companyadmin_events":
      return <EventIcon />;
    case "companyadmin_subscribers":
      return <GroupAddIcon />;
    case "companyadmin_mailchimp":
      return <MarkEmailUnreadIcon />;
    case "companyadmin_news_categories":
      return <CategoryIcon />;
    case "companyadmin_tags":
      return <StyleIcon />;
    case "companyadmin_policybriefs_reports":
      return <PolicyIcon />;
    case "companyadmin_podcasts":
      return <PodcastsIcon />;
    case "companyadmin_news":
      return <AnnouncementIcon />;
    case "companyadmin_laws":
      return <GavelIcon />;
    case "companyadmin_slideshow":
      return <Slideshow />;
    default:
      return null;
  }
};
const buildMenuItem = (feature, isImpersonating, toggleFeature) => {
  const companyId = parseInt(localStorage.getItem("companyId"), 10);

  let featureName = feature.name;
  if (
    companyId === 4 &&
    typeof feature.shortName === "string" &&
    feature.shortName.toLowerCase().includes("team")
  ) {
    featureName = "Deputies";
  }

  const data = {
    segment: feature.shortName,
    title: featureName,
    icon: getIcon(feature.shortName),
  };

  if (isImpersonating) {
    const isFeatureEnabled = feature.is_enabled == "1";
    data.action = (
      <IconButton
        onClick={() => toggleFeature(feature.id, isFeatureEnabled ? 0 : 1)}
        style={{
          backgroundColor: isFeatureEnabled ? "green" : "red",
          color: "white",
          padding: "4px",
        }}
      >
        {!isFeatureEnabled ? (
          <LockIcon style={{ fontSize: "15px", color: "white" }} />
        ) : (
          <DoneIcon style={{ fontSize: "15px", color: "white" }} />
        )}
      </IconButton>
    );
  }

  return data;
};
const getParentSegment = (id) => {
  switch (id) {
    case "2":
    case 2:
      return {
        name: "Themes",
        short_name: "themes",
        icon: <BusinessIcon />,
      };
    case "3":
    case 3:
      return {
        name: "Company",
        short_name: "company",
        icon: <BusinessIcon />,
      };
    case "4":
    case 4:
      return {
        name: "Media",
        short_name: "media",
        icon: <PermMediaIcon />,
      };
    case "5":
    case 5:
      return {
        name: "Subscribers",
        short_name: "subscribers",
        icon: <SubscriptionsIcon />,
      };
  }
};
export const buildNavigation = (features, isImpersonating, toggleFeature) => {
  var navigation = [];
  navigation.push({
    segment: "dashboard",
    title: "Dashboard",
    icon: <DashboardIcon />,
  });
  if (features && features.length) {
    for (var i = 0; i < features.length; i++) {
      var feature = features[i];
      //root
      if (
        feature["fk_featureCategory"] == "1" ||
        feature["fk_featureCategory"] == 1
      ) {
        navigation.push(buildMenuItem(feature, isImpersonating, toggleFeature));
      } else {
        // Check if parent Already Exist
        var found = false;
        for (var t = 0; t < navigation.length; t++) {
          //Parent already Exist
          if (
            navigation[t].segment ==
            getParentSegment(feature["fk_featureCategory"]).short_name
          ) {
            found = true;
            var parent = navigation[t];
            parent.children.push(
              buildMenuItem(feature, isImpersonating, toggleFeature)
            );
            break;
          }
        }
        if (!found) {
          var parent = {
            segment: getParentSegment(feature["fk_featureCategory"]).short_name,
            title: getParentSegment(feature["fk_featureCategory"]).name,
            icon: getParentSegment(feature["fk_featureCategory"]).icon,
            children: [],
          };
          parent.children.push(
            buildMenuItem(feature, isImpersonating, toggleFeature)
          );
          navigation.push(parent);
        }
      }
    }
  }
  navigation.push(
    {
      kind: "header",
      title: "Account",
    },
    {
      segment: "support",
      title: "Support",
      icon: <SupportAgentIcon />,
    },
    {
      segment: "profile",
      title: "Profile",
      icon: <VpnKeyIcon />,
    }
  );
  return navigation;
};

export const renderContent = (pathname, handleLogout) => {
  switch (pathname) {
    case "/dashboard":
      return <Dashboard />;
    case "/companyadmin_wedding":
      return <Weddings />;
    case "/company/companyadmin_team":
      return <Team />;
    case "/company/companyadmin_users":
      return <Users />;
    case "/company/companyadmin_seo":
      return <SEO />;
    case "/companyadmin_promotions":
      return <Promotions />;
    case "/company/companyadmin_languages":
      return <Languages />;
    case "/companyadmin_events":
      return <Events />;
    case "/companyadmin_laws":
      return <Laws />;
    case "/media/companyadmin_slideshow":
      return <SlideshowComponent />;
    case "/media/companyadmin_news":
      return (
        <NewsLetterPolicyBriefs
          formTitle="Newsletter"
          sectionType="newsletter"
          sectionId="3"
        />
      );
    case "/media/companyadmin_policybriefs_reports":
      return (
        <NewsLetterPolicyBriefs
          formTitle="Policy Briefs & Reports"
          sectionType="policybriefs"
          sectionId="4"
        />
      );
    case "/media/companyadmin_podcasts":
      return <Podcasts />;
    case "/media/companyadmin_news_categories":
      return <Categories />;
    case "/media/companyadmin_tags":
      return <Tags />;
    case "/subscribers/companyadmin_subscribers":
      return <Subscribers />;
    case "/subscribers/companyadmin_mailchimp":
      return <MailChimp />;
    case "/profile":
      return <ChangePassword />;
    case "/support":
      return <Support />;
    case "/logout":
      handleLogout();
      break;
    default:
  }
};
